import { addDaysISO } from './planLifecycle.js';

const DAY_ORDER = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/**
 * Per-day prep tasks from the locked week's dinner_events (MEA-191). Nights
 * without a recipe — takeout, leftovers, open — are skipped (nothing to prep).
 * Ordered Mon..Sun. Steps are the recipe's own [{ text, time }] directions.
 *
 * @param {Array}  events     - dinner_events rows [{ event_date, recipe_id, ... }]
 * @param {Object} recipeMap  - { recipeId: recipe }
 * @param {Object} opts       - { weekOf } Monday ISO date, to order/label days
 * @returns {Array}           - [{ date, day, name, prepTime, cookTime, steps }]
 */
export function buildPrepChecklist(events, recipeMap, { weekOf } = {}) {
  const byDate = new Map((events || []).map((e) => [e.event_date, e]));
  return DAY_ORDER.map((day, i) => {
    const date = weekOf ? addDaysISO(weekOf, i) : null;
    const e = date ? byDate.get(date) : undefined;
    if (!e || !e.recipe_id) return null; // takeout / leftovers / open night — no prep
    const r = recipeMap[e.recipe_id];
    if (!r) return null;
    return {
      date,
      day,
      name: r.name || 'Dinner',
      prepTime: r.prep_time_min || 0,
      cookTime: r.cook_time_min || 0,
      steps: Array.isArray(r.steps) ? r.steps : [],
    };
  }).filter(Boolean);
}
